// extracted by mini-css-extract-plugin
export default {"fill-placeholder-child":"fill-placeholder-child_5K5-f","circle":"circle_2xRTh","round":"round_JGYDH","down":"down_qiKF0","left":"left_O5Cmh","right":"right_pHuHa"};